import axios from '../../axios';

const path = '/admin';
const service = {
  async getRoles() {
    return axios({ method: 'get', url: `${path}/roles` });
  },

  async updateUsers(data) {
    return axios({ method: 'put', url: `${path}/users`, data });
  },

  async fetchTag(id) {
    return axios({ method: 'get', url: `/tags${path}/${id}` });
  }
};

export default service;
